import I18n from 'I18n';
import { Children, cloneElement } from 'react';
import { Tooltip } from '../../components/Tooltip/Tooltip';

/* eslint-disable no-script-url */
import { jsx as _jsx } from "react/jsx-runtime";
const NOOP_HREF = 'javascript:void(0)';

// Match the protocol part of an absolute URL, e.g. "http:"
const PROTOCOL_REGEX = /^([^:]+):/;

// Whitespace and control characters are ignored, so we must strip them out
// eslint-disable-next-line no-control-regex
const IGNORED_PROTOCOL_CHARS_REGEX = /[\s\x00-\x1f]/g;
export const isUnsafeUrl = href => {
  if (href && typeof href === 'string') {
    const protocolMatch = href.match(PROTOCOL_REGEX);
    if (!protocolMatch || href === NOOP_HREF) return false;
    if (protocolMatch[0].replace(IGNORED_PROTOCOL_CHARS_REGEX, '').toLowerCase() === 'javascript:') {
      return true;
    }
  }
  return false;
};
export const getSafeUrl = href => {
  if (href && typeof href === 'object' && typeof href.safeHref === 'string') {
    return href.safeHref;
  }
  return isUnsafeUrl(href) ? NOOP_HREF : href;
};
export const XSSTooltip = ({
  children
}) => {
  const child = Children.only(children);
  return /*#__PURE__*/_jsx(Tooltip, {
    title: I18n.text('salesUI.XSSTooltip.explanation'),
    use: "danger",
    children: /*#__PURE__*/cloneElement(child, {
      href: NOOP_HREF
    })
  });
};